import template from './service_checklists.html'
import controller from './service_checklists.controller'
import './service_checklists.scss'

const serviceSettingsComponent = {
    restrict: 'E',
    bindings: {
        acl: '=',
        hasACL: '='
    },
    template,
    controller
}

export default serviceSettingsComponent;


// WEBPACK FOOTER //
// ./client/app/components/service_settings/service-checklist/service_settings.checklist.component.js